import { createAction, props } from "@ngrx/store";
import { ICapability } from "@skills-app/models/capability";

const prefix = "[Primary Capability Search Bar]";

export const loadComponent = createAction(`${prefix} Load Component`);
export const unloadComponent = createAction(`${prefix} Unload Component`);
export const addPrimaryCapabilityToSearch = createAction(
  `${prefix} Add Primary Capability To Search`,
  props<{ capability: ICapability }>(),
);
export const removePrimaryCapabilityFromSearch = createAction(
  `${prefix} Remove Primary Capability From Search`,
  props<{ capability: ICapability }>(),
);
